import { render, staticRenderFns } from "./TreatmentRefer.vue?vue&type=template&id=7be8cdcc"
import script from "./TreatmentRefer.vue?vue&type=script&lang=js"
export * from "./TreatmentRefer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports